
<div>
  <div
    class="banniere-container"
    :style="styleObjectContainer"
    @click="isOuvert = !isOuvert"
  ></div>
  <div
    v-if="texteHTML || mixinEnvironnement_inEditor"
    :id="content.idHTML"
    class="right_slider ui-slideouttab-panel ui-slideouttab-right ui-slideouttab-panel-reverse"
    :class="[jel_getClassObject(content), { 'position-fixed': !mixinEnvironnement_inEditor }]"
    :style="styleObjectSlider"
  >
    <b-link
      class="handle ui-slideouttab-handle-rounded ui-slideouttab-handle ui-slideouttab-handle-reverse imageTracked"
      :data-component-gacategory="content.googleAnalyticsBannierreLaterale?.eventCategory"
      :data-component-gaaction="content.googleAnalyticsBannierreLaterale?.eventAction"
      :data-component-galabel="content.googleAnalyticsBannierreLaterale?.eventLabel"
      @click="isOuvert = !isOuvert"
    >
      {{ content.titre }}
    </b-link>
    <b-link class="icomoon icon-cross close-button" @click="isOuvert = !isOuvert"></b-link>
    <div
      class="texte-conteneur"
      :class="[{ 'overflow-auto': isPlusGrandEcran }]"
      v-html="texteHTML"
    ></div>
  </div>
</div>
